import React, { Component, ReactNode } from 'react';
import { REGISTERED_APPS } from '../shared/types/Apps';
import sendErrorToSentry from '../utils/sentry';

interface State {
  hasError: boolean;
}

interface ErrorBoundaryProps {
  app?: REGISTERED_APPS;
  onError?: () => void;
  children?: ReactNode;
}

export class Boundary extends Component<ErrorBoundaryProps> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  state: State = {
    hasError: false,
  };

  componentDidCatch(error: Error, errorInfo: any) {
    const { onError } = this.props;
    sendErrorToSentry(error, this.props.app, errorInfo);
    if (onError) {
      onError();
    }
  }

  render() {
    if (this.state.hasError) {
      return <div></div>;
    }
    return this.props.children;
  }
}
